import { post } from './apiService';

export const sendLoginData = async (token, email) => {
  return await post('kc', {email, token});
};

const LoginService = {
  sendLoginData,
};

export default LoginService;